import React from 'react';

export interface CompactTileContextValue {
  openDetails: () => void;
  closeDetails: () => void;
}

export const CompactTileContext = React.createContext<CompactTileContextValue | null>(null);
